// import DeviceList from './index';
export default {
  priority: 80,
  path: "backup",
  permissions: ["TimeAttendanceMenu/RestoreDbMenu"],

  // component: DeviceList,
  component: load(() => import(/* webpackChunkName: "DeviceList" */ "./index")),
  name: app.translate("پشتیبان گیری"),
  icon: "deskphone",
  drawer: true,
};
